import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { GlobalCacheConfig } from 'ts-cacheable';

import 'hammerjs';

import { environment } from './environments/environment';
import { purgeCachedEntries, QuotaSafeLocalStorageStrategy } from './shared/utils/quota-safe-local-storage.strategy';
import RootModule from './root.module';

GlobalCacheConfig.storageStrategy = QuotaSafeLocalStorageStrategy;

// Drop the pre-split location cache entry: it contains the full district polygons (several MB)
// and can keep the shared CACHE_STORAGE blob at the localStorage quota until logout.
purgeCachedEntries(['LocationLoader#loadSerializable']);

if (environment.production) {
    enableProdMode();
}

platformBrowserDynamic()
    .bootstrapModule(RootModule, { applicationProviders: [provideZoneChangeDetection()] })
    .catch((err) => console.error(err));
